import { render, staticRenderFns } from "./CitasContainer.vue?vue&type=template&id=6035cb77&scoped=true"
import script from "./CitasContainer.vue?vue&type=script&lang=js"
export * from "./CitasContainer.vue?vue&type=script&lang=js"
import style0 from "./CitasContainer.vue?vue&type=style&index=0&id=6035cb77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035cb77",
  null
  
)

export default component.exports